import { Exclude, Expose, Transform } from 'class-transformer';

export class MatchPlayer {

  public id: string;
  public rank: string;
  public amountSets: number;
  public amountGames: number;

}



// WEBPACK FOOTER //
// ./src/app/models/MatchPlayer.ts